<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import { mdiPlusCircle, mdiFilePdfBox, mdiFileTableOutline, mdiInformationOutline, mdiPrinter } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import IconRounded from "@/Components/IconRounded.vue";
import VueSelect from "vue3-select-component";

const props = defineProps({
    //records: Array,
    template: String,
    title: String,
    fileName: String,
    students: Object,
    classrooms: Object,
    //ciclos: Object,
    isAdmin: Boolean,
    isCoord: Boolean,
    plantilla: String,
    options: Object

});
//let elementsDisabled = getElementsByTagName('input', 'select');
const loading = ref(false)
const resource = ref('reportcalification')
const errors = ref({})
const error = ref('')
const form = ref({
    'anio_consulta': '',
    'id_student': 0,
    'id_classroom': 0,
    'id_classroom_ugel': 0,
    'ref_ciclo': '',
    'is_sort_nombre': false,
    'sort_nombre': false,
    'is_sort_puntaje': false,
    'sort_puntaje': false,
    'template': props.template
})
const options = {
    'show_descriptiva_competencia': 0,
    'show_cursos': 0,
    'show_detalle_sinordenmerito': 0
}
const filters = ref([])
const records = ref([])
//const id_classroom = ref(0)
//const ref_ciclo= ref(0)

const getRecords = async () => {
    if (props.template == 'calificationsugel' || props.template == 'calificationsugelpromedio' || props.template == 'calificationsugelimport') {
        if (form.value.id_classroom_ugel == 0) { // <-- !form.value.ref_ciclo Para Periodo anual
            //this.$message.error('Seleccionar estudante');
            if (!form.value.id_classroom_ugel) error.value = 'Debe escoger un aula'
            if (!form.value.ref_ciclo) error.value += ' Debe escoger un periodo'
            return false;
        } else {
            error.value = '';
        }
    } else if (props.template == 'calificationsbymerito') {
        if (form.value.id_classroom == 0) {
            //this.$message.error('Seleccionar estudante');
            if (!form.value.id_classroom) error.value = 'Debe escoger un aula'
            return false;
        } else {
            error.value = '';
        }
    } else {
        if (form.value.id_classroom == 0 || !form.value.ref_ciclo) {
            //this.$message.error('Seleccionar estudante');
            if (!form.value.id_classroom) error.value = 'Debe escoger un aula'
            if (!form.value.ref_ciclo) error.value += ' Debe escoger un periodo'
            return false;
        } else {
            error.value = '';
        }
    }

    loading.value = true;
    records.value = [];
    await axios.post(`/${resource.value}/records`, form.value)
        .then(response => {
            records.value = response.data;
        });
    loading.value = false;
    getTextSelectAula()
    if (props.template == 'calificationsbymerito') {
        procesarListado('calificationsbymerito')
    }
}

const sortNombre = () => {
    form.value.is_sort_nombre = true;
    form.value.is_sort_puntaje = false;
    form.value.sort_nombre = !form.value.sort_nombre;
    getRecords();
}

const exportFile = async (format) => {
    loading.value = true;
    // this.loadingSubmit = true;
    errors.value = {};
    console.log('cr_ugel ' + form.value.id_classroom_ugel)
    console.log('cr ' + form.value.id_classroom)
    console.log('ciclo ' + form.value.ref_ciclo)
    await axios({
        url: `/${resource.value}/export`,
        method: 'POST',
        responseType: 'blob',
        data: {
            'records': records.value,
            'format': format,
            'template': props.template,
            'id_classroom': form.value.id_classroom ? form.value.id_classroom : form.value.id_classroom_ugel,
            //'id_classroom_ugel': form.value.id_classroom_ugel,
            'ref_ciclo': form.value.ref_ciclo,
            'anio_consulta': form.value.anio_consulta,
            'options': JSON.stringify(options)
        }
    }).then(response => {
        let res = response.data;
        if (res.type === 'application/json') {
            //this.$message.error('Error al exportar');
            console.log('Error al exportar')
        } else {
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement('a');
            link.href = url;
            //link.setAttribute('download', 'calificacioness_' + Date.now() + '.' + format);
            if (format == 'preview') {
                link.target = "_blank";
                link.setAttribute('view', props.fileName + '.html');
            } else {
                link.setAttribute('download', props.fileName + '_' + aulaText.value + '.' + format);
            }
            document.body.appendChild(link);
            link.click();
        }
    }).catch(error => {
        console.log(error);
        errors.value = error;
    }).then(() => {
        loading.value = false;
    });
    // this.loadingSubmit = false;
    //

}

const number2nota = (notaN) => {
    let nota = parseFloat(notaN).toFixed(2);
    let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
    //console.log(nota)
    return result
}

const aulaText = ref('')
const getTextSelectAula = () => {
    let selectedVal = form.value.id_classroom_ugel || form.value.id_classroom;

    // Si el componente VueSelect retorna el objeto completo, extraer el id o value
    if (selectedVal && typeof selectedVal === 'object') {
        selectedVal = selectedVal.id || selectedVal.value;
    }

    // Buscar el aula coincidente usando find (soporta tanto id como value)
    const classroom = props.classrooms.find(c => c.id == selectedVal || c.value == selectedVal);

    if (classroom) {
        if (form.value.id_classroom_ugel) {
            aulaText.value = (classroom.ref_mc ? classroom.ref_mc + '-' : '') + classroom.label;
        } else {
            aulaText.value = classroom.label;
        }
    } else {
        aulaText.value = '';
    }
}

/**
 * Estructurar nuevo listado
 */
const nuevoListadoActive = ref(false)
const nuevoListado = ref([])
const procesarListado = (template) => {
    const arrObjs = []; // Array de objetos
    const arr = records.value
    if (template == 'calificationsbymerito') {
        arr.forEach((record, index) => {
            let siexiste = checkExistObject(arrObjs, 'id_student', record.id_student)

            if (siexiste) {
                arrObjs.find(item => item.id_student === record.id_student).total_acumulado += parseInt(record.promediods)
            } else {
                arrObjs.push({
                    id_student: record.id_student,
                    fullname: record.fullname,
                    ref_ciclo: record.ref_ciclo,
                    total_acumulado: record.promediods
                });
            }

        });

        // ORdenar objetos según el campo y de mayor a menor (descendente)
        orderList('total_acumulado', 'desc', arrObjs)
    }
    // Agregar más estructuras de templates con else if('') ...

    nuevoListado.value = arrObjs
    if (arrObjs.length) {
        nuevoListadoActive.value = true
    }

    console.log(nuevoListado.value.length)
}

// Si existe el objeto según el atributo en un array de objetos
const checkExistObject = (arrObj, attr, val) => {
    return arrObj.some((obj) => obj[attr] == val)
}

// Ordenar listado
const orderList = (orderfield, sort = '', objs) => {
    objs.sort((a, b) => {
        if (sort == 'asc') {
            return a[orderfield] - b[orderfield]
        } else if (sort == 'desc') {
            return b[orderfield] - a[orderfield]
        } else {
            return a[orderfield] - b[orderfield]
        }
    });
}

// Ordenar listado sólo números no string <---------------
const sortUp = ref(false)
const sortDown = ref(false)
const sortnodefine = ref(false)
const orderColumn = (orderfield, sort = '', objs = nuevoListado.value) => {

    // Si no se define sort
    if (!sort) {
        sortnodefine.value = !sortnodefine.value
        if (sortnodefine.value) {
            sort = 'asc'
            sortUp.value = false
            sortDown.value = true
        } else {
            sort = 'desc'
            sortUp.value = true
            sortDown.value = false
        }
    }

    orderList(orderfield, sort, objs)
    nuevoListado.value = objs
    console.log('ordercolumnchanged')

}

// Calcular puesto
const calcularPuesto = (puesto, lastPuntaje, puntaje) => {
    // Si hay puntajes iguales se repite los puestos, de lo contrario se mantiene el puesto anterior <-- existen puestos duplicados
    if (lastPuntaje != puntaje) {
        puesto++
    }
    console.log(lastPuntaje + ' - ' + puntaje)
    return puesto
}
</script>

<template>
    <Head :title="title" />

    <BreezeAuthenticatedLayout>
        <template #header>
        <PremiumPageHeader :title="title" :subtitle="'Gestión de ' + title">
            <template #buttons>
                <BaseButton :classLabel="'hidden sm:block'" color="info" :icon="mdiPlusCircle" small label=" Nuevo" class="inline-flex" />
            </template>
        </PremiumPageHeader>
    </template>

        <div>

            <!-- Loader -->
            <div v-if="loading" class="flex flex-col justify-center items-center md:h-[calc(100vh_-113px)] h-[calc(100vh-_114px)] absolute bottom-0 bg-white w-full z-50 bg-opacity-80">
                <!-- LRR Loader Pulso <div class="mb-10">
                    <div class="relative inline-flex">
                        <div class="w-8 h-8 bg-rose-600 rounded-full"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-ping"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
                    </div>
                </div> -->
                <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
                <p class="text-rose-600">Procesando ...</p>
                <!-- LRR Button loader <div>
                    <button type="button"
                        class="inline-flex  items-center btn btn-rose text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg ">
                        <div class="border-rose-400 h-5 w-5 animate-spin rounded-full border-4 border-t-white mr-2" />
                        Cargando
                    </button>
                </div> -->
            </div>
            <div><!--max-w-7xl-->
                <div class="bg-white overflow-hidden border shadow-lg rounded-md" :class="loading ? 'pointer-events-none' : ''">

                    <div class="p-4 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <!-- <div>
                          <label for="list_periodo-choice">Escoge un periodo:</label>
                          <input type="search" placeholder="Periodo" list="list-periodos" id="list_periodo-choice" name="list_periodo-choice" style="width: 300px;">
                          <datalist
                              id="list-periodos"
                              name="list-periodos"
                              class="flat">
                              <option v-for="option in ciclos" :value="option.id">{{ option.label }}</option>
                          </datalist>
                        </div> -->


                        <div class="mb-4 text-center">
                            <input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="form.anio_consulta" :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR" @change="getRecords()">
                        </div>

                        <div class="mb-4">
                            <ul>
                                <li>Tomar en cuenta que la información puede variar si actualizan las calificaciones luego de descargar el reporte.
                                    <BaseIcon :path="mdiInformationOutline" size="15" title="La nota Nivel de logro se calcula como la siguiente fórmula;
                                Nota menor a 10.5 = C, Nota mayor o igual a 10.50 y menor a 3.50 = B, Nota mayor o igual a 13.50 y menor a 7.50 = A,
                                Nota mayor o igual a 17.50 y menor a 20 = AD,
                                cualquier otro dato mostrará  Error = E" />
                                </li>
                                <li>Sólo se muestran alumnos activos si el año de consulta es el año lectivo actual. Las consultas de años anteriores si hay alguna inconsistencia debe verificar la historia del estudiante.</li>
                                <li>El promedio A.S. Es el promedio Antes del Simulacro, el D.S. es el promedio Después del Simulacro, depende de este si sube un punto adicional o no.</li>
                            </ul>
                        </div>

                        <div class="grid grid-cols-1 gap-3 md:grid-cols-3 relative">

                            <div>
                                <label class="block font-bold mb-2 ml-2">Bimestre</label>
                                <select v-model="form.ref_ciclo" @change="getRecords()" class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                    <option value="" selected>Todos</option>
                                    <option value="B1">Primer Bimestre</option>
                                    <option value="B2">Segundo Bimestre</option>
                                    <option value="B3">Tercer Bimestre</option>
                                    <option value="B4">Cuarto Bimestre</option>
                                    <!-- <option v-if="template=='calificationsugel'" value="B5">Promedio Anual</option> -->
                                </select>
                            </div>

                            <div v-if="template != 'calificationsugel' && template != 'calificationsugelpromedio' && template != 'calificationsugelimport'">
                                <label class="block font-bold mb-2 ml-2">Aula de estudio</label>
                                <VueSelect class="select-search-light max-h-[38px]" v-model="form.id_classroom" :options="classrooms" :get-option-label="(option) => `${option.label}`" placeholder="Seleccionar aula de estudio" />
                                <!-- <select v-model="form.id_classroom" @change="getRecords()" class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                    <option value="0" selected>Seleccionar un aula</option>
                                    <option v-for="option in classrooms" :value="option.id">{{ option.label }}</option>
                                </select> -->
                                <small v-if="classrooms.length <= 0" class="text-red-500">Es probable que no tenga permisos para las aulas de estudio</small>
                            </div>
                            <div v-else>
                                <label class="block font-bold mb-2 ml-2">Aula UGEL</label>
                                <VueSelect class="select-search-light max-h-[38px]" v-model="form.id_classroom_ugel" :options="classrooms" :get-option-label="(option) => `${option.ref_mc} - ${option.label}`" placeholder="Seleccionar aula ugel" />
                                <!-- <select v-model="form.id_classroom_ugel" @change="getRecords()" class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                    <option value="0" selected>Seleccionar un aula</option>
                                    <option v-for="option in classrooms" :value="option.id">{{ option.label + ' - ' + option.ref_mc }}</option>
                                </select> -->
                                <small v-if="classrooms.length <= 0" class="text-red-500">Es probable que no tenga permisos para las aulas UGEL</small>
                            </div>

                            <div v-if="template == 'calificationsugel' || template == 'calificationsugelpromedio'">
                                <template v-if="template == 'calificationsugelpromedio'" class="block">
                                    <input id="show_cursos" v-model="options.show_cursos" type="checkbox" class="ml-2" />
                                    <label for="show_cursos" class="checkbox mb-2 ml-2">Mostrar cursos</label>
                                </template>
                                <template class="inline-block">
                                    <input id="show_descriptiva_competencia" v-model="options.show_descriptiva_competencia" type="checkbox" class="ml-2" />
                                    <label for="show_descriptiva_competencia" class="checkbox mb-2 ml-2">Mostrar conclusión descritptiva</label>
                                </template>

                            </div>
                            <div v-if="template == 'calificationsbymerito'">
                                <!-- <template class="inline-block">
                              <input id="show_detalle_sinordenmerito" v-model="options.show_detalle_sinordenmerito" type="checkbox" class="ml-2"/>
                              <label for="show_detalle_sinordenmerito" class="checkbox mb-2 ml-2">Mostrar opción de imprimr</label>
                            </template> -->
                                <template class="inline-block">
                                    <input id="show_detalle_sinordenmerito" v-model="options.show_detalle_sinordenmerito" type="checkbox" class="ml-2" />
                                    <label for="show_detalle_sinordenmerito" class="checkbox mb-2 ml-2">Exportar detallado sin orden de puesto</label>
                                </template>

                            </div>
                        </div>
                        <!-- <div class="mt-4">
                          <div class="relative">
                            <label class="block font-bold mb-2 ml-1">Estudiante</label>
                            <select v-model="form.id_student" @change="getRecords()"
                              class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="0" selected>Todos</option>
                              <option v-for="option in students" :value="option.id">{{ option.apellidos + ' ' + option.nombres }}</option>
                            </select>
                          </div>
                        </div> -->

                        <div class="mt-4"> <!-- v-if="records.length" -->
                            <!-- <div class="inline-block pr-2 ml-1" @click="exportFile('pdf')">
                            Exportar
                            <IconRounded color="" :icon="mdiFilePdfBox" title="Exportar a PDF" class="ml-1 text-red-800"
                             /> 
                          </div> -->
                            <div class="inline-block ml-4" v-if="$page.props.auth.user.id_rol == 1">
                                <BaseButton :disabled="records.length <= 0" @click="exportFile('preview')" color="info" :icon="mdiFileTableOutline" label="Vista debug txt" small target="_blank" />
                            </div>
                            <div class="inline-block ml-4">
                                <!--  Procesar -->
                                <BaseButton @click="getRecords()" color="danger" :icon="mdiFileTableOutline" label="Procesar" small />
                            </div>
                            <div class="inline-block ml-4">
                                <!--  :href="'/reportasistencia/preview?id_collaborator='" -->
                                <BaseButton :disabled="records.length <= 0 || loading" :class="records.length <= 0 ? 'pointer-events-none' : ''" :href="'/reportcalification/export/preview?template=' + template + '&options=' + JSON.stringify(options) + '&ref_ciclo=' + form.ref_ciclo + '&id_classroom=' + form.id_classroom + '&id_classroom_ugel=' + form.id_classroom_ugel + '&anio_consulta=' + form.anio_consulta" color="info" :icon="mdiFileTableOutline" label="Vista previa" small target="_blank" />
                            </div>
                            <div class="inline-block ml-4">
                                <BaseButton :disabled="records.length <= 0 || loading" @click="exportFile('xlsx')" color="success" :icon="mdiFileTableOutline" label="Exportar" small target="_blank" />
                            </div>
                            <div v-if="nuevoListado.length" class="inline-block ml-4">
                                <BaseButton :disabled="records.length <= 0 || loading" @click="nuevoListadoActive = !nuevoListadoActive" color="warning" :icon="mdiFileTableOutline" :label="nuevoListadoActive ? 'Ver detalle de lista' : 'Ver lista original'" small />
                            </div>

                            <!-- <div v-if="modulo=='payementOrder' && showDownloadTxt && countChecked" class="inline-block">
                            <IconRounded color="" :icon="mdiFileDocument" title="Exportar a txt" class="ml-1 text-blue-700"
                            @click="exportFile('txt')" />
                          </div> -->
                        </div>
                        <CardBox v-if="records.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto">
                                <!-- listado dependiendo del template -->
                                <table v-if="nuevoListado.length && template == 'calificationsbymerito' && nuevoListadoActive" class="table-responsive">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Nombre</th>
                                            <th title="La suma de todos los promedios" @click="orderColumn('total_acumulado')">Puntaje Acumulado
                                                <span v-if="sortUp" class="text-red-600">(^)</span>
                                                <span v-else-if="sortDown" class="text-red-600">(v)</span>
                                                <span v-else></span>
                                            </th>
                                            <th>Puesto</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody :set="objPuntaje = { lastPuntaje: 0, puesto: 0 }">
                                        <tr v-for="(row, index) in nuevoListado" :key="row.id">
                                            <td data-label="#">
                                                {{ index + 1 }}
                                            </td>
                                            <td data-label="Nombre" :set="puesto = calcularPuesto(objPuntaje.puesto, objPuntaje.lastPuntaje, row.total_acumulado)">
                                                {{ row.fullname }}
                                            </td>
                                            <!-- Primero calculamos el puntaje luego agregamos el lastPuntaje -->
                                            <td data-label="Puntaje Acumulado" :set="objPuntaje.puesto = puesto">
                                                {{ row.total_acumulado }}
                                            </td>
                                            <td data-label="Puesto" :set="objPuntaje.lastPuntaje = row.total_acumulado">
                                                {{ puesto }}
                                            </td>
                                            <td data-label="Action">

                                                <!-- BaseButtons genera error EN EL PUESTO -->
                                                <BaseButton color="info" :icon="mdiPrinter" label="Diploma" small :href="'/calification/diploma' + '?id=' + row.id_student + '&puesto=' + puesto + '&anio_consulta=' + form.anio_consulta" target="_blank" />

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- Listado Original -->
                                <table v-else class="table-responsive">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th @click="sortNombre">Nombre
                                                <i v-if="form.is_sort_nombre && form.sort_nombre" class="fas fa-sort-up"></i>
                                                <i v-else-if="form.is_sort_nombre" class="fas fa-sort-down"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </th>
                                            <th>Bimestre</th>
                                            <th>Curso</th>

                                            <th title="Promedio Antes del Simulacro">Promedio A.S.</th>
                                            <th title="Resultado de Simulacro">R. Simulacro</th>
                                            <th title="Promedio después del Simulacro">Promedio D.S</th>
                                            <th>Nivel de logro</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in records" :key="row.id">
                                            <td data-label="#">
                                                {{ index + 1 }}
                                            </td>
                                            <td data-label="Nombre">
                                                {{ row.fullname }}
                                            </td>
                                            <td data-label="Bimestre">
                                                {{ row.ref_ciclo }}
                                            </td>
                                            <td data-label="Curso">
                                                {{ row.label_short_course ? row.label_short_course : row.label_course }}
                                            </td>

                                            <td data-label="Promedio A.S.">
                                                {{ row.promedio }}
                                            </td>
                                            <!--<td data-label="Progress" class="lg:w-32">
                                    <progress
                                        class="flex w-2/5 self-center lg:w-full"
                                        max="100"
                                        :value="row.progress"
                                    >
                                        {{ row.progress }}
                                    </progress>
                                    </td>
                                    -->
                                            <td data-label="R. Simulacro" class="lg:w-1 whitespace-nowrap">
                                                <small :class="(row.simulacro_admision < 1 ? 'text-red-600' : (row.simulacro_admision == 1 ? 'text-green-600' : ''))" :title="row.simulacro_admision">{{ (row.simulacro_admision == 1 ? 'Aprobado' : (row.simulacro_admision == 2 ? 'Ausente' : 'Desaprobado')) }}
                                                </small>
                                            </td>
                                            <td data-label="Promedio D.S">
                                                {{ row.promediods }}

                                            </td>

                                            <td data-label="Nivel de logro">
                                                {{ number2nota(row.promediods) }}

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>